import { createFileRoute, useRouteContext } from '@tanstack/react-router';

import { OrganizationNotificationSettings } from '../../../../modules/organization/components/organization-notification-settings';
import { SettingsLayoutContent } from '../../../../ui/components/layout';

const SettingsNotificationsRoute = () => {
  const { selectedOrganization, selectedMembership } = useRouteContext({
    from: '/_authenticated/_app',
  });

  const organizationId = selectedOrganization.id;
  const organizationMembershipId = selectedMembership.id;

  return (
    <SettingsLayoutContent
      title="Notifications"
      description="Choose how you want to be notified about important updates."
    >
      <OrganizationNotificationSettings
        organizationId={organizationId}
        organizationMembershipId={organizationMembershipId}
        readonlyKeys={selectedMembership.role.name === 'Owner' ? ['criticalAlerts'] : undefined}
      />
    </SettingsLayoutContent>
  );
};

export const Route = createFileRoute('/_authenticated/_app/settings/notifications')({
  component: SettingsNotificationsRoute,
});
